import { PERMISSIONS } from "../constants/permissions";

const ALL_REQUIRED_PERMISSION = Object.values(Object.fromEntries(Object.entries(PERMISSIONS).filter(([key]) => key !== PERMISSIONS.EXT_SIGN_LOCK)));

const EXTERNAL_USER_PERMISSION = Object.values(PERMISSIONS);

const EXTERNAL = [
  PERMISSIONS.PATIENT,
  PERMISSIONS.ADD_PATIENT,
  PERMISSIONS.WOUND_ASSESSMENT_WITHOUT_PHOTO,
  PERMISSIONS.RISK_ASSESSMENT,
  PERMISSIONS.UNABLE_TO_ACCESS_WOUND,
  PERMISSIONS.REGISTER_PATIENT_FOR_MOBILE,
  PERMISSIONS.ADT_EDIT,
  PERMISSIONS.RE_EVAL,
  PERMISSIONS.CUSTOM_LABEL,
  PERMISSIONS.ANATOMY_EDIT,
  PERMISSIONS.ASSESSMENT,
  PERMISSIONS.CHARACTERISTIC,
  PERMISSIONS.CHARACTERISTIC_HISTORY_EDIT,
  PERMISSIONS.CHARACTERISTIC_TISSUE_EDIT,
  PERMISSIONS.CHARACTERISTIC_TOUCH_EDIT,
  PERMISSIONS.CHARACTERISTIC_CUSTOM_FORM_EDIT,
  PERMISSIONS.CHARACTERISTIC_CLASSIFICATION_EDIT,
  PERMISSIONS.CHARACTERISTIC_PROGRESS_EDIT,
  PERMISSIONS.MEASUREMENT,
  PERMISSIONS.MEASUREMENT_BUTTON,
  PERMISSIONS.MEASUREMENT_EDIT,
  PERMISSIONS.TREATMENT,
  PERMISSIONS.TREATMENT_SEARCH,
  PERMISSIONS.TREATMENT_ADD_INTERVENTION,
  PERMISSIONS.TREATMENT_EDIT,
  PERMISSIONS.NOTES,
  PERMISSIONS.ASSESSMENT_NOTE_DELETE,
  PERMISSIONS.NOTIFICATION_EDIT,
  PERMISSIONS.USER_PROFILE,
  PERMISSIONS.USER_PROFILE_UPDATE_PASSWORD,
];

export const ROLE_PERMISSIONS = {
  MedlineAdministrator: ALL_REQUIRED_PERMISSION,
  MedlineStandardUser: ALL_REQUIRED_PERMISSION,
  MedlineSupport: ALL_REQUIRED_PERMISSION,
  ExternalAdministrator: EXTERNAL_USER_PERMISSION,
  ExternalStandardUser: [
    PERMISSIONS.WORKLIST_ROUTE,
    PERMISSIONS.PATIENT,
    PERMISSIONS.ADD_PATIENT,
    PERMISSIONS.RISK_ASSESSMENT,
    PERMISSIONS.UNABLE_TO_ACCESS_WOUND,
    PERMISSIONS.ADT_EDIT,
    PERMISSIONS.RE_EVAL,
    PERMISSIONS.USER_PROFILE,
    PERMISSIONS.USER_PROFILE_UPDATE_PASSWORD,
    PERMISSIONS.MEASUREMENT,
    PERMISSIONS.MEASUREMENT_BUTTON,
    PERMISSIONS.MEASUREMENT_EDIT,
    PERMISSIONS.NOTES,
    PERMISSIONS.ASSESSMENT_NOTE_DELETE,
  ],
  ExternalNE1WoundExpert: [
    ...EXTERNAL,
    PERMISSIONS.WORKLIST_ROUTE,
    PERMISSIONS.TRANSFER_WOUND_ASSESSMENT_ROUTE,
    PERMISSIONS.MERGE_WOUND_ASSESSMENT_ROUTE,
    PERMISSIONS.ASSESSMENT_THREE_DOT_MENU,
    PERMISSIONS.LOCK,
    PERMISSIONS.SIGN,
  ],
  ExternalNE1Review: [...EXTERNAL, PERMISSIONS.WORKLIST_ROUTE, PERMISSIONS.EXT_SIGN_LOCK],
  ExternalNE1Assesment: [...EXTERNAL, PERMISSIONS.WORKLIST_ROUTE, PERMISSIONS.SIGN],
  ExternalNE1ReadOnly: [PERMISSIONS.USER_PROFILE_UPDATE_PASSWORD],
};
